// import styles
import './scss/index.scss';

// import JS files
import './js/gsap';
import './js/mobile-nav';
import './js/pagination-infinite-scroll';
import './js/recent-insights-global';

document.addEventListener("DOMContentLoaded", function (event) {
	window.onload = function () {
		window.requestAnimationFrame(function () {
			document.querySelector('body').style.opacity = '1';
		});
	};
});
